import React from 'react'
import PropTypes from 'prop-types'

import {
  orderApi
} from 'api'

import CustomerForm from './CustomerForm'



export default function EditCustomerFormWrapper({ t, customer, fields, onSubmit }) {
  const handleSubmit = React.useCallback((payload) => {
    orderApi.editCustomer(customer.id, payload)
      .then(() => {
        if (onSubmit) {
          onSubmit()
        }
      })
  })

  return (
    <CustomerForm
      t={t}
      customer={customer}
      fields={fields}
      onSubmit={handleSubmit}
    />
  )
}

EditCustomerFormWrapper.propTypes = {
  t: PropTypes.func.isRequired,
  customer: PropTypes.object.isRequired,
  fields: PropTypes.array,
  onSubmit: PropTypes.func,
}